module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.storeStatus && _vm.storeStatus.warnings) ? _c('div', {
    staticClass: "ui warning icon message"
  }, [_c('i', {
    staticClass: "info circle icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n      Informācijai\n    ")]), _vm._v(" "), _c('p', [_vm._v("Daļa no precēm nav pievienotas Autoship, jo tās iespējams iegādāties tikai izmantojot standarta pasūtījumu:")]), _vm._v(" "), (_vm.storeStatus.warnings && _vm.storeStatus.warnings.skipped_goods) ? _c('ul', _vm._l((_vm.storeStatus.warnings.skipped_goods), function(item) {
    return _c('li', [_c('b', [_vm._v(_vm._s(item.goods_name))])])
  }), 0) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f06d0c92!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SkippedGoodsWarning.vue
// module id = 368
// module chunks = 1